export const createSimpleEventEmitter = ({ debug = false }) => {
  let n = 0;
  const subCallbacks = {};
  const incrementSubscriptionKey = () => n++;
  const pub = (e, payload = {}) => {
    debug && console.log("Event", e, payload);
    Object.values(subCallbacks).forEach((cb) => cb(e, payload));
  };
  const unsub = (key) => delete subCallbacks[key];
  const sub = (cb) => {
    subCallbacks[n] = cb;
    const unsubFunc = () => unsub(n);
    incrementSubscriptionKey();
    return unsubFunc;
  };

  return {
    pub,
    sub,
    unsub,
  };
};
